var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-content',{attrs:{"loader":_vm.isLoading,"items":_vm.imageList,"type":"image","fileTypes":_vm.fileType},scopedSlots:_vm._u([{key:"item-preview",fn:function(ref){
var url = ref.url;
return [_c('img',{staticClass:"multimedia__thumbnail",attrs:{"src":url}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }